import type { VehicleHistoryListItem } from "@slfinrtl/ui-bff-routes"

export type GroupedVehicleHistoryListItem = VehicleHistoryListItem & { additionalItems?: VehicleHistoryListItem[] }

export const groupByEventType = (items: VehicleHistoryListItem[]): GroupedVehicleHistoryListItem[] => {
	return items.reduce((acc: GroupedVehicleHistoryListItem[], item) => {
		const lastItem = acc.at(-1)
		if (lastItem?.eventType !== item.eventType) {
			acc.push({ ...item })
		} else {
			lastItem.additionalItems ??= []
			lastItem.additionalItems.push({ ...item })
		}
		return acc
	}, [])
}
